module.exports = __webpack_public_path__ + "img/circle01.380d106f.png";